import React from "react";
import Radio from "antd/lib/radio";
import {
  SurveyQuestionCard,
  SymptomAlertCard,
  AnswerList,
  AnswerOption,
  FormItemStyle,
  AsteriskStyle,
  CardTitle
} from "pages/symptoms/surveyForms/surveyFormComponents";

interface LegSwellingSectionSectionProps {
  readonly currentPage: number;
}

export const LegSwellingSectionSection: React.FC<
  LegSwellingSectionSectionProps
> = ({ currentPage }) => {
  return (
    <>
      {currentPage === 12 && (
        <SurveyQuestionCard
          sectionTag="LEG SWELLING"
          title="Have you noticed any leg swelling during dialysis?"
          required
        >
          <FormItemStyle
            name="Have you had any leg swelling"
            label=""
            rules={[{ required: true }]}
            initialValue={""}
          >
            <Radio.Group
              value={localStorage.getItem("haveYouHadAnyLegSwelling")}
              onChange={e => {
                localStorage.setItem(
                  "haveYouHadAnyLegSwelling",
                  e.target.value
                );
              }}
            >
              <AnswerList>
                <AnswerOption value="NONE">NONE</AnswerOption>
                <AnswerOption value="Mild up to ankles or shins only">
                  Mild up to ankles or shins only
                </AnswerOption>
                <AnswerOption value="Moderate, up to knees">
                  Moderate, up to knees
                </AnswerOption>
                <AnswerOption value="Severe, up to thighs">
                  Severe, up to thighs
                </AnswerOption>
              </AnswerList>
            </Radio.Group>
          </FormItemStyle>
        </SurveyQuestionCard>
      )}
      {currentPage === 13 && (
        <SymptomAlertCard message="Please discuss your symptoms of leg swelling with your nurse or doctor and dietician, regarding dietary sodium restriction, and other treatment changes" />
      )}
    </>
  );
};
